import { render, staticRenderFns } from "./WallCoverBlockSettings.vue?vue&type=template&id=3c4ba6d6"
import script from "./WallCoverBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallCoverBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports